module.exports = __webpack_public_path__ + "static/fonts/Montserrat200.94603128.ttf";